.root {
    text-align: center;

    & > div {
        padding: 1.5rem;
    }
}
